// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.content_box {\n  padding:10px;\n  border-color:#C7DAFF;\n}\n.content_box .tab li.on {\n  height:31px;\n  border-bottom:0;\n  border-top:1px solid #C7DAFF;\n}\n.content_box .tab li.on a {\n  background-color:#F0F5FF;\n}\n.float_calcu_box {\n  position: fixed;\n  top:120px;\n  width: 303px;\n}\n.footer .hidden{\n  visibility: hidden;\n}\n", ""]);
// Exports
module.exports = exports;
